'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Thumbnail;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Core React


function Thumbnail(props) {
  var imageSrc = props.imageSrc,
      size = props.size,
      rounded = props.rounded;

  var width = function width(setSize) {
    var setWidth = void 0;

    switch (setSize) {
      case 'small':
        setWidth = '60px';
        break;

      case 'medium':
        setWidth = '80px';
        break;

      case 'large':
        setWidth = '100px';
        break;

      default:
        setWidth = '80px';
    }

    return {
      setWidth: setWidth
    };
  };

  var roundedCorners = rounded ? width(size).setWidth : 'unset';
  var styles = {
    width: width(size).setWidth,
    height: width(size).setWidth,
    padding: '.5em',
    borderRadius: roundedCorners
  };
  return _react2.default.createElement('img', {
    style: styles,
    src: imageSrc,
    alt: 'avatar preview'
  });
}

Thumbnail.propTypes = {
  /** Image source for Avatar */
  imageSrc: _propTypes2.default.string.isRequired,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};
Thumbnail.defaultProps = {
  size: 'medium'
};